<script setup>
defineProps({
  dark: Boolean,
  light: Boolean,
  to: { type: String, default: '/' },
  src: { type: String },
  srcDark: { type: String },
})

const { isDark } = useSite()

const site = useState('site')

const logoDefault = site.value.logo || '/logo.png'
const logoDefaultDark = site.value.logo || '/logo.png'

const configLogo = null
const configLogoDark = null
</script>

<template lang="pug" scoped>
nuxt-link(
  :to="to"
).block.h-16
  div(:style="{ backgroundImage: `url('${((isDark || dark) && !light) ? (srcDark || src || configLogoDark || configLogo || logoDefaultDark) : (src || configLogo || logoDefault)}')` }").block.h-full.w-auto.bg-contain.bg-no-repeat.bg-left
</template>
